// Version 3: Angaben in der Fußzeile. Firmendaten aus src/data/seo.js (SITE).
// Social Media: echte Adressen der Parto Konten (S-01, 30.10.2026), gelten für alle Versionen mit dieser Fußzeile.
// href leer würde wieder den Platzhalter Hinweis zeigen.
export const V3_SOCIAL = [
    { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/partosolution" },
    { id: "instagram", label: "Instagram", href: "https://www.instagram.com/partosolution/" },
    { id: "facebook", label: "Facebook", href: "https://www.facebook.com/people/Parto-Solution/61595631807271/" },
    { id: "youtube", label: "YouTube", href: "https://www.youtube.com/@parto-solution" },
];

export const V3_FOOTER = {
    de: {
        claim: "Mehr Wert aus industriellen Beständen, wirtschaftlich und im Kreislauf. Ein Ansprechpartner und ein integrierter Prozess von der Analyse bis zur Verwertung.",
        // Englischer Claim, laut Briefing nur dezent (Fußzeile, Über Parto)
        claimEn: "The Infrastructure for Industrial Asset Circularity.",
        sell: "Verkaufen und verwerten",
        cta: "Anfrage senden",
        contact: "Kontakt", company: "Firmenangaben", social: "Folgen Sie uns",
        directors: "Geschäftsführer", register: "Registergericht", vat: "USt-IdNr.",
        imprint: "Impressum", privacy: "Datenschutz", llm: "Informationen für KI",
        socialMissing: "[Platzhalter: Link folgt]",
        rights: "Alle Rechte vorbehalten.",
    },
    en: {
        claim: "[Placeholder: more value from industrial assets]",
        claimEn: "The Infrastructure for Industrial Asset Circularity.",
        sell: "[Sell and recycle]",
        cta: "[Send inquiry]",
        contact: "Contact", company: "Company details", social: "Follow us",
        directors: "Managing directors", register: "Register court", vat: "VAT ID",
        imprint: "Imprint", privacy: "Privacy", llm: "Information for AI",
        socialMissing: "[Placeholder: link will follow]",
        rights: "All rights reserved.",
    },
};
